import {all} from 'redux-saga/effects';

import {createFetchSagaLatest} from 'utils/sagas';

import {
  fetchWebhooks as fetchWebhooksAction,
  fetchSchedulerRunsChartData as fetchSchedulerRunsChartDataAction
} from './';

import {fetchWebhooks, fetchSchedulerRunsChartData} from 'sdk/webhooks';

function* webhooksSaga() {
  yield all([
    createFetchSagaLatest(fetchWebhooksAction, fetchWebhooks),
    createFetchSagaLatest(
      fetchSchedulerRunsChartDataAction,
      fetchSchedulerRunsChartData
    )
  ]);
}

export default webhooksSaga;
